export const SettingsTranslations = {
  en: {
    settings: {
      title: "Settings",
      language: "Language",
      measurementSystem: "Measurement System",
      theme: "Theme",
      save: "Save Changes",
      languages: {
        en: "English",
        es: "Spanish",
      },
      units: {
        imperial: "Imperial system",
        si: "International system",
      },
      themes: {
        dark: "Dark",
        light: "Light",
        system: "System",
      },
    },
  },

  es: {
    settings: {
      title: "Ajustes",
      language: "Idioma",
      measurementSystem: "Sistema de medición",
      theme: "Tema",
      save: "Guardar cambios",
      languages: {
        en: "Inglés",
        es: "Español",
      },
      units: {
        imperial: "Sistema imperial",
        si: "Sistema internacional",
      },
      themes: {
        dark: "Oscuro",
        light: "Claro",
        system: "Sistema",
      },
    },
  },
};
